// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { headerClickableStyles } from "@west/App/Components/Header/HeaderClickable";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        & > ${IconWrapper}, & > ${TypographyStyle} {
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        }

        &:hover > ${IconWrapper}, &:hover > ${TypographyStyle} {
            color: ${color("common.ui10")};
        }

        &:focus {
            outline: none;
        }

        &.opened {
            & > ${IconWrapper}, & > ${TypographyStyle} {
                color: ${color("common.ui10")};
            }

            & > .arrow-menu-icon {
                transform: rotate(180deg);
            }
        }
    `,
};

headerClickableStyles.icon = {
    size: 16,
    color: "common.ui5",
    css: css`
        ${xScreen("lte", "sm")} {
            &,
            & > svg {
                width: 20px;
                height: 20px;
            }
        }
    `,
};

headerClickableStyles.cartIcon = {
    size: 22,
    color: "common.ui8",
    css: css`
        ${xScreen("lte", "sm")} {
            &,
            & > svg {
                width: 20px;
                height: 20px;
            }
        }
    `,
};

headerClickableStyles.arrowIcon = {
    size: 12,
    color: "common.ui4",
    css: css`
        margin-left: 8px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerClickableStyles.title = {
    size: 14,
    weight: "bold",
    color: "text.main",
    transform: "capitalize",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        white-space: nowrap;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerClickableStyles.cartTotalDisplay = {
    css: css`
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        aspect-ratio: 1 / 1;
        top: -50%;
        left: -10px;
        padding: 4px;
        border-radius: 50%;
        min-width: 22px;
        min-height: 22px;
        background: ${color("common.ui6")};
        color: ${color("common.white")};
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 20px;
    `,
};
